(() => {
  const HERO_SLIDE_UPDATES_20260610 = [
    null,
    {
      "desktop": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_1_d8cd0008-b180-4f85-a87a-ec9e1dc78400.png?v=1781609311",
      "mobile": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_2_3e3ae1a9-e630-404a-a610-5e6af31fa3df.png?v=1781609308",
      "link": "https://callingjune.com/collections/men",
      "ariaLabel": "Shop Father's Day"
    },
    {
      "desktop": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_3_43083bfa-363c-4686-90ee-32f7c9344bdd.png?v=1781077616",
      "mobile": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_2_1f5a4594-7789-45d6-bc5b-cab4d91722c7.png?v=1781077611",
      "link": "https://callingjune.com/collections/dresses/products/male-maxi-dress-nautilus-black",
      "ariaLabel": "Explore Summer Edit"
    },
    {
      "desktop": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_5_bcbe4bd5-e0f9-43b0-840d-c3d0ccf796f7.png?v=1781243147",
      "mobile": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_4_ba482cd7-992a-4e36-bcbe-6319de8c537f.png?v=1781243137",
      "link": "https://callingjune.com/collections/summer-edit",
      "ariaLabel": "Explore The Little Black Dress"
    },
    {
      "desktop": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_7_3a4fb353-2135-499d-b10a-0494d0435149.png?v=1780742584",
      "mobile": "https://cdn.shopify.com/s/files/1/0608/8605/7127/files/image_6_be9c3136-5778-4284-86d2-16d8d31e63e8.png?v=1780742583",
      "link": "https://callingjune.com/collections/bestsellers",
      "ariaLabel": "Explore Bestsellers"
    }
  ];

  const applyHeroSlideUpdate = (slide, update) => {
    if (!slide || !update) return;

    slide.href = update.link;
    slide.setAttribute("aria-label", update.ariaLabel);

    const image = slide.querySelector("img");
    if (image) {
      image.setAttribute("src", update.desktop);
    }

    const source = slide.querySelector("source");
    if (source) {
      source.setAttribute("srcset", update.mobile);
    }
  };

  const refreshHeroCampaignImages = (root) => {
    const slides = Array.from(root.querySelectorAll("[data-cj-hero-slide]"));
    HERO_SLIDE_UPDATES_20260610.forEach((update, index) => {
      applyHeroSlideUpdate(slides[index], update);
    });
  };

  const syncHeroCampaignLinks = (slides) => {
    HERO_SLIDE_UPDATES_20260610.forEach((update, index) => {
      applyHeroSlideUpdate(slides[index], update);
    });
  };

  const bindHero = (root) => {
    if (!root || root.dataset.cjBound === "true") return;

    refreshHeroCampaignImages(root);
    const slides = Array.from(root.querySelectorAll("[data-cj-hero-slide]"));
    const dots = Array.from(root.querySelectorAll("[data-cj-hero-dot]"));
    syncHeroCampaignLinks(slides);

    if (slides.length <= 1) {
      root.dataset.cjBound = "true";
      return;
    }

    let index = Math.max(slides.findIndex((slide) => slide.classList.contains("is-active")), 0);
    let timer = null;

    const render = () => {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("is-active", slideIndex === index);
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-current", active ? "true" : "false");
      });
    };

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      render();
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => goTo(index + 1), 6000);
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => {
        goTo(dotIndex);
        start();
      });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);

    render();
    start();
    root.dataset.cjBound = "true";
  };

  const bindSlider = (root) => {
    if (!root || root.dataset.cjBound === "true") return;

    const slides = Array.from(root.querySelectorAll("[data-cj-slider-slide]"));
    const dots = Array.from(root.querySelectorAll("[data-cj-slider-dot]"));
    const prev = root.querySelector("[data-cj-slider-prev]");
    const next = root.querySelector("[data-cj-slider-next]");
    if (!slides.length) return;

    let index = Math.max(slides.findIndex((slide) => slide.classList.contains("is-active")), 0);
    let timer = null;

    const render = () => {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("is-active", slideIndex === index);
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-current", active ? "true" : "false");
      });
    };

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      render();
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      if (root.dataset.cjSliderAutoplay === "false" || slides.length <= 1) return;
      stop();
      timer = window.setInterval(() => goTo(index + 1), 5500);
    };

    prev?.addEventListener("click", () => {
      goTo(index - 1);
      start();
    });

    next?.addEventListener("click", () => {
      goTo(index + 1);
      start();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => {
        goTo(dotIndex);
        start();
      });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);

    render();
    start();
    root.dataset.cjBound = "true";
  };

  const bindRail = (root) => {
    if (!root || root.dataset.cjBound === "true") return;

    const viewport = root.querySelector("[data-cj-rail-viewport]");
    const prev = root.querySelector("[data-cj-rail-prev]");
    const next = root.querySelector("[data-cj-rail-next]");
    if (!viewport || !prev || !next) return;

    const update = () => {
      const maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth - 2, 0);
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll;
    };

    const scrollByViewport = (direction) => {
      viewport.scrollBy({
        behavior: "smooth",
        left: viewport.clientWidth * 0.92 * direction
      });
    };

    prev.addEventListener("click", () => scrollByViewport(-1));
    next.addEventListener("click", () => scrollByViewport(1));
    viewport.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    update();
    root.dataset.cjBound = "true";
  };

  const bindVideos = (scope) => {
    scope.querySelectorAll(".cj-homepage__gram-video").forEach((video) => {
      if (video.dataset.cjVideoBound === "true") return;

      const play = () => {
        const promise = video.play();
        if (promise && typeof promise.catch === "function") {
          promise.catch(() => {});
        }
      };

      play();
      video.addEventListener("loadeddata", play, { once: true });
      video.dataset.cjVideoBound = "true";
    });
  };

  const bindAll = (scope = document) => {
    scope.querySelectorAll("[data-cj-hero]").forEach(bindHero);
    scope.querySelectorAll("[data-cj-slider]").forEach(bindSlider);
    scope.querySelectorAll("[data-cj-rail]").forEach(bindRail);
    bindVideos(scope);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bindAll());
  } else {
    bindAll();
  }

  document.addEventListener("shopify:section:load", (event) => bindAll(event.target));
})();
